import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { RadioButton } from "../forms/elements";
import { Container, Row, Col, Button, ButtonGroup } from "react-bootstrap"; // Redux

import { cartDuck } from "../../ducks/cart";
var cartOperations = cartDuck.operations;

function jsUcfirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export var TravelOpts = function TravelOpts(props) {
  var _props$deliveryOption = props.deliveryOptions,
      deliveryOptions = _props$deliveryOption === void 0 ? [] : _props$deliveryOption,
      _props$deliveryCosts = props.deliveryCosts,
      deliveryCosts = _props$deliveryCosts === void 0 ? [] : _props$deliveryCosts,
      title = props.title,
      _props$setFieldValue = props.setFieldValue,
      setFieldValue = _props$setFieldValue === void 0 ? function () {
    return "";
  } : _props$setFieldValue,
      _props$saveDeliveryMo = props.saveDeliveryMode,
      saveDeliveryMode = _props$saveDeliveryMo === void 0 ? function () {
    return console.log('Save delivery mode method');
  } : _props$saveDeliveryMo,
      values = props.values,
      store = props.store;
  var name = title.toLowerCase() + "Delivery";

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      travel = _useState2[0],
      setTravel = _useState2[1];

  var handleOptionChange = function handleOptionChange(changeEvent) {
    if (changeEvent.target.value) {
      var mode = changeEvent.target.value.toLowerCase();
      saveDeliveryMode(mode);
      setFieldValue(name, mode);
      return setTravel(mode);
    }
  };

  useEffect(function () {
    if (Array.isArray(deliveryOptions) && deliveryOptions.length && !travel) {
      handleOptionChange({
        target: {
          value: deliveryOptions[0]
        }
      });
    }
  }, [deliveryOptions]);
  return /*#__PURE__*/React.createElement("fieldset", {
    className: ""
  }, /*#__PURE__*/React.createElement("legend", {
    className: "visuallyhidden"
  }, "".concat(title, " Delivery Options")), deliveryOptions.length >= 1 ? "" : /*#__PURE__*/React.createElement("p", null, "No online ordering setup for this location"), /*#__PURE__*/React.createElement(Row, null, deliveryOptions.map(function (option, index) {
    var childtitle = option;

    if (option === "dispatch") {
      childtitle = "delivery";
    }

    if (option === "pickup") {
      childtitle = "In-Store Pickup";
    }

    var cost = deliveryCosts[index];
    return /*#__PURE__*/React.createElement(Col, {
      className: "cb-no-padding",
      key: "".concat(name, "Delivery").concat(index)
    }, /*#__PURE__*/React.createElement(TravelButton, {
      title: jsUcfirst(childtitle),
      id: title + option,
      name: name,
      isPickup: option === "pickup",
      value: option.toLowerCase(),
      onChange: handleOptionChange,
      selected: travel,
      deliverytime: cost || ""
    }));
  })));
};
export var TravelButton = function TravelButton(_ref) {
  var title = _ref.title,
      name = _ref.name,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return console.log("CHANGE");
  } : _ref$onChange,
      selected = _ref.selected,
      deliverytime = _ref.deliverytime,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? title : _ref$value,
      id = _ref.id;
  var className = selected === value.toLowerCase() ? "is-active" : "";
  return /*#__PURE__*/React.createElement(Button, {
    className: "btn w-100 pl-0 pr-0",
    name: name,
    style: {
      color: className ? "white" : "#653024",
      backgroundColor: className ? "#9d2235" : "white",
      fontWeight: className ? "bolder" : "",
      borderColor: "#653024"
    },
    id: id || title,
    value: value,
    checked: selected === value.toLowerCase(),
    onClick: onChange // onChange={onChange}
    // labelClass={className}

  }, title);
};
export var TravelRadioOptions = function TravelRadioOptions(props) {
  var _props$deliveryOption2 = props.deliveryOptions,
      deliveryOptions = _props$deliveryOption2 === void 0 ? [] : _props$deliveryOption2,
      _props$deliveryCosts2 = props.deliveryCosts,
      deliveryCosts = _props$deliveryCosts2 === void 0 ? [] : _props$deliveryCosts2,
      title = props.title,
      _props$setFieldValue2 = props.setFieldValue,
      setFieldValue = _props$setFieldValue2 === void 0 ? function () {
    return "";
  } : _props$setFieldValue2;
  var name = title.toLowerCase() + "Delivery";

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      travel = _useState4[0],
      setTravel = _useState4[1];

  var handleOptionChange = function handleOptionChange(changeEvent) {
    if (changeEvent.target.value) {
      setFieldValue(name, changeEvent.target.value.toLowerCase());
      return setTravel(changeEvent.target.value.toLowerCase());
    }
  };

  useEffect(function () {
    if (Array.isArray(deliveryOptions) && deliveryOptions.length && !travel) {
      handleOptionChange({
        target: {
          value: deliveryOptions[0]
        }
      });
    }
  }, [deliveryOptions]);
  return /*#__PURE__*/React.createElement("fieldset", {
    className: "cb-cart__travel-group"
  }, /*#__PURE__*/React.createElement("legend", {
    className: "visuallyhidden"
  }, "".concat(title, " Delivery Options")), deliveryOptions.length >= 1 ? "" : /*#__PURE__*/React.createElement("p", null, "No online ordering setup for this location"), /*#__PURE__*/React.createElement(Row, null, deliveryOptions.map(function (option, index) {
    var childtitle = option;

    if (option === "dispatch") {
      childtitle = "delivery";
    }

    var cost = deliveryCosts[index];
    return /*#__PURE__*/React.createElement(Col, {
      key: "".concat(name, "Delivery").concat(index)
    }, /*#__PURE__*/React.createElement(TravelButton, {
      title: jsUcfirst(childtitle),
      id: title + option,
      name: name,
      isPickup: option === "pickup",
      value: option.toLowerCase(),
      onChange: handleOptionChange,
      selected: travel,
      deliverytime: cost || ""
    }));
  })));
};
export var TravelRadioButton = function TravelRadioButton(_ref2) {
  var title = _ref2.title,
      name = _ref2.name,
      _ref2$onChange = _ref2.onChange,
      onChange = _ref2$onChange === void 0 ? function () {
    return console.log("CHANGE");
  } : _ref2$onChange,
      selected = _ref2.selected,
      deliverytime = _ref2.deliverytime,
      _ref2$value = _ref2.value,
      value = _ref2$value === void 0 ? title : _ref2$value,
      id = _ref2.id;
  var className = selected === value.toLowerCase() ? "is-active" : "";
  return /*#__PURE__*/React.createElement(RadioButton, {
    name: name,
    id: id || title,
    value: value,
    checked: selected === value.toLowerCase(),
    onChange: onChange,
    labelClass: className
  }, /*#__PURE__*/React.createElement("h3", {
    className: "cb-cart__item__copy"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "cb-cart__item__copy--sm"
  }, /*#__PURE__*/React.createElement("span", null, deliverytime)));
};

var mapStateToProps = function mapStateToProps(state) {
  return _objectSpread({}, state);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    saveDeliveryMode: function saveDeliveryMode(mode) {
      return dispatch(cartOperations.saveDeliveryMode(mode));
    }
  };
};

var TravelOptions = connect(mapStateToProps, mapDispatchToProps)(TravelOpts);
export { TravelOptions };